import { render } from "./LegalNotice.vue?vue&type=template&id=4aa95f9e"
import script from "./LegalNotice.vue?vue&type=script&lang=ts"
export * from "./LegalNotice.vue?vue&type=script&lang=ts"
script.render = render

export default script